import Modal from "@mui/material/Modal";
import {Grid} from "@mui/material";
import {IoClose} from "react-icons/io5";
import Button from "@mui/material/Button";
import React from "react";
import '../../SelfServe/InfluencerStepper.css';
import OneOffPaymentImage from '../../../media/site_media/dashboard/oneoffpayments.jpg'
import GemmaOneToOneImage from '../../../media/site_media/dashboard/PaidDMsGemma.webp';
import {gtag} from "ga-gtag";

export default function PaidDMsExplainer(props) {
   // Opened with props passed from -> http://localhost:3000/become-a-creator/register
   return(

      <Modal
         open={props.open}
         onClose={() => props.closeExplainerModal()}
         aria-labelledby="modal-modal-title"
         aria-describedby="modal-modal-description"
         disableAutoFocus={true}
         sx={{ display: 'flex', overflow: 'auto', height: 'auto', outline: 'none', border: 'none',}}
      >
         <div style={{ width: '100%', height: '100%', overflow: 'auto', outline: 'none', border: 'none', display: 'flex'}}>



            <Grid container justifyContent='center' sx={{
            width:'auto', margin: 'auto',
             outline: 'none'}}>

               <Grid
                  style={{
                     zIndex: '100',
                     justifyContent: 'flex-end',
                     alignItems: 'center',
                     padding: '30px 30px',
                     boxSizing: 'border-box',
                     width: '100%',
                     outline: '0px',
                     width: '100%',
                     maxWidth: '1200px',
                     minHeight: props.windowWidth >= 900 ? '600px' : (props.windowWidth < 900 ? '100vh' : 'auto'),
                     height: props.windowWidth >= 900 ? 'auto' : (props.windowWidth < 900 ? 'auto' : 'auto'),
                     maxHeight: props.windowWidth >= 900 ? '600px' : '',
                     padding: '0px 0px',
                     borderRadius: props.windowWidth >= 900 ? '8px' : '0px',
                     backgroundColor: 'white',
                     textAlign: 'left',
                     // borderRadius: '10px',
                     height: 'auto',
                     // minHeight: 'auto',
                     position: 'relative',
                     margin: props.windowWidth < 400 ? '0' : '0 auto',
                  }}
               >
         
            

                  <div style={{position: 'absolute', top: '10px', right: '10px', '&:hover': {cursor: 'pointer'}}}>
                     <a onClick={() => { props.closeExplainerModal() }}>
                        <IoClose className={'modal-close-icon'}/>
                     </a>
                  </div>

                  <Grid container sx={{justifyContent: "left", alignItems: "left", display: "flex", zIndex: '1000', height: '100%'}}>

                     <Grid xs={12} md={5}>
                        <div style={{ width: '100%', height: '100%', borderRadius: '8px', display: 'flex' }}>
                        <img loading="lazy" src={GemmaOneToOneImage}
                             style={{ width: '80%', height: 'auto', margin: 'auto auto', overflow: 'hidden', borderRadius: '8px', }}/>
                     </div></Grid>
                     <Grid xs={12} md={7}>
                     <div style={{width: '100%', height: '100%', display: 'flex', }}>
                        {/*<h3 style={{fontSize: '28px', margin: '10px auto 0px auto', textAlign: 'center'}}></h3>*/}
                        <div style={{ display: 'block', margin: 'auto', width: props.windowWidth > 900 ? '100%' : '90%' , maxWidth: props.windowWidth > 900 ? '' : '500px', paddingBottom: props.windowWidth > 900 ? '' : '50px'}}>

                        <h3 style={{margin: '10px auto 25px auto', textAlign: 'left', fontSize: '24px',}}>New to Messages?</h3>

                        <p className={'onboarding_description'} style={{
                                 padding: '0px 0px 25px 0px', fontWeight: '500', width: props.windowWidth > 900 ? '90%' : '100%', margin: 'auto auto auto 0px', textAlign: 'left', fontSize: '15px', lineHeight: '18px', marginTop: '20px', color: '#6E89AF',
                              }}>


                                 {/*  What is it - DMS */}
                                 {/*  How do you use it - Ask a question, give some praise, or simply say hello. The choice is yours.
                                 During the interation, after you have sent your message, the creator will respond as soon as possible. Depending on your message, 
                                 the creator has the option to extend the conversation ensuring you get the value of your purchase. */}
                                 {/* Why do you need it - creators are often busy with lots going on and aren't able to respond via regular social channels. Now you can get the answers you need, right away! */}

                              
                                    <>

                                       Introducing Messages on WithMe – Now, you can directly message your favorite creators and experts.
                                       <br /><br />
                                       Whether you're a loyal follower or a new admirer, for a nominal fee, you can engage in meaningful conversations and glean valuable insights from your beloved creators.
                                       <br /><br />
                                       Creators lead busy lives, often inundated with message requests from various social channels, making it easy for yours to get lost in the shuffle, leaving your questions unanswered. But worry no more!

                                       Now, you can promptly receive the answers you seek for a small fee, which not only supports the creator but also ensures your queries are addressed without delay!
                                       <br /><br />
                                       Feel free to ask questions, share your appreciation, submit content, or simply say hello. The choice is yours.

                                       Throughout the interaction and after sending your message, the creator will respond as promptly as possible. Depending on the nature and complexity of your inquiry, the creator may choose to extend the conversation.
                                       <br /><br />
                                       Like you, the creator can respond with images, videos, guides, audio files, and more, ensuring you derive the utmost value from your purchase.

                                       So, all that's left to do is to purchase your direct message and dive right in. The creators eagerly anticipate hearing from you!
                                    </>
                                 
                              </p>

                              <Button variant="contained" onClick={() => {
                                 // gtag('event', 'one_off_payment_popup', {
                                 //    'event_category': 'Popup',
                                 //    'event_label': 'One Off Payment Popup'
                                 // });
                                 props.openCheckout();
                                 props.closeExplainerModal();


                              }} disableElevation
                             sx={{
                                marginTop: '20px',
                                padding: '5px 25px',
                                width: props.windowWidth < 900 ? '100%' : 'auto',
                              //   maxWidth: '400px',
                                textAlign: 'center',
                                display: 'inline-block',
                                margin: '5px auto',
                                borderRadius: '8px',
                                textTransform: 'none',
                                border: '2px var(--brand-color) solid',
                                backgroundColor: 'var(--brand-color)',
                                '&:hover': {
                                   backgroundColor: 'var(--brand-color-hover)',
                                   border: '2px var(--brand-color-hover) solid',
                                }
                             }}>
                           <span className="fa fa-search"
                                 style={{fontWeight: '600', fontSize: '16px'}}>Get Started</span>
                        {/*<span style={{ fontSize: '10px', position: 'absolute', marginLeft: '4px', fontWeight: '600' }}>WORTH £49</span>*/}
                     </Button>


                        </div>
                     </div>

                     
                     </Grid>


                     


                    

                  </Grid>
               </Grid>
            </Grid>
         </div>
      </Modal>
   )

}


